import logger from '3-foundation/Logging/logger';
import { mapNavigationPageSettings } from './PageSettings/navigationMapper';
import { mapOpenGraph } from './PageSettings/openGraphMapper';

export const mapPageSettings = (items: Umbraco.ContentModule[]): Content.BasePage['pageSettings'] => {
	return items.map((item) => {
		try {
			switch (item.content?.contentType) {
				case 'navigation':
					return mapNavigationPageSettings({ content: item.content });
				case 'openGraph':
					return mapOpenGraph({ content: item.content });
			}
		} catch (e) {
			const errorMessage = `No page setting mapper found for content type: ${item.content.contentType}. \nCause: ${e.message}`;
			logger.error(errorMessage);
			throw new Error(errorMessage, { cause: e });
		}
	});
};
